module.exports = "<div class=\"progress\" [className]=\"progress ? 'progress': 'no-progress'\">\n  <div class=\"indeterminate\"></div>\n</div>\n"